<template>
  <div class="checkbox-filter">
    <div class="checkbox">
      <input type="checkbox" id="checkbox" v-model="checkOnlyPaid" @change="onChangeOnlyPaid"/>
      <label for="checkbox">{{ $t("Show revenue by paid orders") }}</label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'UiCheckboxRevenue',
  data () {
    return {
      checkOnlyPaid: false
    }
  },
  computed: {
    ...mapGetters({
      getQuery: 'report/getQuery'
    })
  },
  watch: {
    getQuery: function (newOptions) {
      this.checkOnlyPaid = newOptions.revenueType || false
    }
  },
  methods: {
    onChangeOnlyPaid () {
      this.$emit('onChangeOnlyPaid', this.checkOnlyPaid)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-filter {
  padding-bottom: 15px;
  font-size: 15px;
  color: #3E5B7E;
  .checkbox {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  label {
    padding-left: 5px;
  }
}
</style>
